<template>
  <div class="container-fluid">
    <div class="row no-gutter">
      <!-- The image half -->
      <div class="col-md-6 d-none d-md-flex bg-image"></div>
      <!-- The content half -->
      <div class="col-md-6 bg-light">
        <div class="login d-flex align-items-center py-5">
          <!-- Demo content-->
          <div class="container">
            <div class="row">
              <div class="col-lg-10 col-xl-7 mx-auto">
                <h3 class="display-4">/> Corridor</h3>
                <p class="text-muted mb-4">
                  A Real-time student project management system
                </p>
                <form>
                  <div class="form-group mb-3">
                    <input
                      v-model.trim="email"
                      @input="clearErrors"
                      type="email"
                      name="email"
                      class="form-control rounded-pill border-0 shadow-sm px-4"
                      placeholder="Email"
                      required=""
                    />
                  </div>
                  <div class="form-group mb-3">
                    <input
                      v-model.trim="password"
                      type="password"
                      password="password"
                      placeholder="Password"
                      required=""
                      class="form-control rounded-pill border-0 shadow-sm px-4 text-primary"
                    />
                  </div>

                  <button
                    @click.prevent="login"
                    type="submit"
                    class="btn btn-primary btn-block text-uppercase mb-2 rounded-pill shadow-sm"
                    v-if="!isLoading"
                  >
                    Login
                  </button>
                  <button class="btn btn-primary form-control" disabled v-else>
                    Please wait...
                  </button>
                  <big class="form-text"
                    >No Account?
                    <router-link to="Register">Register</router-link>
                    <span class="float-right text-success" @click.prevent="fp">
                      <span v-if="!fpform">Forgot password</span>
                      <span v-else>
                        <i class="fa fa-close text-danger"></i>
                      </span>
                    </span>
                  </big>
                  <br />
                  <div class="alert alert-danger" v-if="hasErrors">
                    <div v-for="error in errors" :key="error">{{ error }}</div>
                  </div>
                </form>
                <!-- forgot password form -->
                <form v-if="fpform">
                  <div class="input-group">
                    <input
                      v-model.trim="forgot_password"
                      type="email"
                      name="forgot_password"
                      class="form-control"
                      placeholder="Email to send password reset link"
                    />
                    <button
                      @click.prevent="forgotPassword"
                      class="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                  <br />
                  <!-- show loading statue -->
                  <div class="alert alert-info" v-if="loading">
                    <div>Please wait...</div>
                  </div>
                  <!-- show errors -->
                  <div class="alert alert-danger" v-if="hasErrors">
                    <div v-for="error in errors" :key="error">{{ error }}</div>
                  </div>
                </form>

                <!-- social login -->
                <div class="google text-center mt-4">
                  <button
                    @click="loginWithGoogle"
                    class="btn btn-danger btn-lg btn-block"
                  >
                    Login with Google
                  </button>
                </div>
                
              </div>
            </div>
          </div>
          <!-- End -->
        </div>
      </div>
      <!-- End -->
    </div>
  </div>
</template>

    <script>
import auth from "firebase/auth";
import database from "firebase/database";

export default {
  name: "login",

  data() {
    return {
      email: "",
      password: "",
      forgot_password: "",
      fpform: false,
      errors: [],
      loading: false,
      usersRef: firebase.database().ref("users"),
    };
  },

  computed: {
    hasErrors() {
      return this.errors.length > 0;
    },
  },

  methods: {
    login() {
      console.log("login");
      this.errors = [];

      if (!this.isFormValid()) {
        this.isLoading = true;

        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then((response) => {
            let user = response.user;
            console.log(user);

            this.$store.dispatch("setUser", user);
            this.$router.push("/");
          })
          .catch((error) => {
            this.errors.push(error.message);
            this.isLoading = false;
          });
      }
    },
    isFormValid() {
      if (
        this.email.length > 0 &&
        this.email.length <= 6 &&
        this.password.length > 0 &&
        this.password.length <= 6
      ) {
        return true;
      }
      return false;
    },

    forgotPassword() {
      console.log("forgot password", this.forgot_password);
      firebase
        .auth()
        .sendPasswordResetEmail(this.forgot_password)
        .then((success) => {
          this.fpform = false;
          alert("Check your email for password reset link");
          this.$router.push("/");
        })
        .catch((error) => {
          alert(error.message);
        });
    },

    fp() {
      return (this.fpform = !this.fpform);
    },

    loginWithGoogle() {
      // loading set to true
      this.loading = true;
      // clear old errors
      this.errors = [];

      firebase
        .auth()
        .signInWithPopup(new firebase.auth.GoogleAuthProvider())
        .then((response) => {
          // console.log(response.user)

          // pass user to save in db
          this.saveUserToUsersRef(response.user);

          // dispatch setUser action
          this.$store.dispatch("setUser", response.user);
          // then redirect user to '/' page
          this.$router.push("/");
        })
        .catch((error) => {
          this.errors.push(error.message);
          // set loading to false
          this.loading = false;
        });
    },

    // save user to database
    saveUserToUsersRef(user) {
      return this.usersRef.child(user.uid).set({
        name: user.displayName,
        avatar: user.photoURL,
      });
    },

    loginWithTwitter() {
      // loading set to true
      this.loading = true;
      // clear old errors
      this.errors = [];

      firebase
        .auth()
        .signInWithPopup(new firebase.auth.TwitterAuthProvider())
        .then((response) => {
          // console.log(response.user)

          // dispatch setUser action
          this.$store.dispatch("setUser", response.user);
          // then redirect user to '/' page
          this.$router.push("/");
        })
        .catch((error) => {
          this.errors.push(error.message);
          // set loading to false
          this.loading = false;
        });
    },

    clearErrors() {
      this.errors = [];
    },
  },
};
</script>

    <style>
.login,
.image {
  min-height: 100vh;
}
.bg-image {
  background-image: url("https://therichpost.com/wp-content/uploads/2021/02/login-split.jpg");
  background-size: cover;
  background-position: center center;
}
</style>


// WEBPACK FOOTER //
// src/pages/login.vue